var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","xs":"3"}},[_c('v-img',{attrs:{"src":require("../../assets/images/layout/logo-instituto-prohemoce-iph.png")}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }